import { render, staticRenderFns } from "./PatientsClinicalPicture.vue?vue&type=template&id=b041cec0"
import script from "./PatientsClinicalPicture.vue?vue&type=script&lang=js"
export * from "./PatientsClinicalPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports